import { Address } from '@/models/address'

const addresses: Address[] = [
  {
    street: '54A Nguyễn Chí Thanh',
    ward: 'Phường Láng Thượng, Quận Đống Đa',
    city: 'Hà Nội',
    slug: 'ha-noi',
    coordinate: {
      lat: 21.023678587586748,
      lng: 105.8093954490063,
    },
  },
  {
    street: 'Toà 170 La Thành',
    ward: 'P. Ô Chợ Dừa, Q. Đống Đa',
    city: 'Hà Nội',
    slug: 'ha-noi',
    coordinate: {
      lat: 21.020913582678535,
      lng: 105.82757349715416,
    },
  },
  {
    street: '29 Liễu Giai',
    ward: 'P. Ngọc Khánh, Q. Ba Đình',
    city: 'Hà Nội',
    slug: 'ha-noi',
    coordinate: {
      lat: 21.031278254602107,
      lng: 105.81348851249842,
    },
  },
  {
    street: '46 Thanh Nhàn',
    ward: 'Hai Bà Trưng',
    city: 'Hà Nội',
    slug: 'ha-noi',
    coordinate: {
      lat: 21.00298711050782,
      lng: 105.85795258180968,
    },
  },
  {
    street: '131 Nguyễn Văn Cừ',
    ward: 'Phường Ngọc Lâm, Quận Long Biên',
    city: 'Hà Nội',
    slug: 'ha-noi',
    coordinate: {
      lat: 21.042268513751893,
      lng: 105.86993756831846,
    },
  },
  {
    street: '101 Huỳnh Thúc Kháng',
    ward: 'P.Tân Lập',
    city: 'Nha Trang',
    slug: 'nha-trang',
    coordinate: {
      lat: 12.24348295727918,
      lng: 109.19068575469274,
    },
  },
  {
    street: '09 Pasteur',
    ward: 'P. Xương Huân',
    city: 'Nha Trang',
    slug: 'nha-trang',
    coordinate: {
      lat: 12.251958580900409,
      lng: 109.1952873681847,
    },
  },
  {
    street: '166 Nguyễn Thái Học',
    ward: 'P.Vạn Thạnh',
    city: 'Nha Trang',
    slug: 'nha-trang',
    coordinate: {
      lat: 12.257647392118217,
      lng: 109.19008143934884,
    },
  },
  {
    street: '1/6 Võ Thị Sáu',
    ward: 'P.Vĩnh Trường',
    city: 'Nha Trang',
    slug: 'nha-trang',
    coordinate: {
      lat: 12.206070772124976,
      lng: 109.20283345469237,
    },
  },
  {
    street: '18 Hai Bà Trưng',
    ward: 'Phường Bến Nghé, Quận 1',
    city: 'TP Hồ Chí Minh',
    slug: 'tp-ho-chi-minh',
    coordinate: {
      lat: 10.777037163688448,
      lng: 106.7050423393331,
    },
  },
  {
    street: '114 Trần Đình Xu',
    ward: 'Phường Nguyễn Cư Trinh, Quận 1',
    city: 'TP Hồ Chí Minh',
    slug: 'tp-ho-chi-minh',
    coordinate: {
      lat: 10.762350714504608,
      lng: 106.68915108166105,
    },
  },
  {
    street: '424 Nguyễn Thị Minh Khai',
    ward: 'Phường 5, Quận 3',
    city: 'TP Hồ Chí Minh',
    slug: 'tp-ho-chi-minh',
    coordinate: {
      lat: 10.770409469583077,
      lng: 106.68583832584115,
    },
  },
  {
    street: '226 Cách Mạng Tháng 8',
    ward: 'Phường 10, Quận 3',
    city: 'TP Hồ Chí Minh',
    slug: 'tp-ho-chi-minh',
    coordinate: {
      lat: 10.780285421686042,
      lng: 106.67790969515303,
    },
  },
]

export { addresses }
